import React from "react";

export const Contact = () => (
    <div>
        <h3>聯絡我們</h3>
        <p>建置中</p>
    </div>
);
